import { EmptyState } from '@/components/ui';
import { SKIP_REASON_LABEL } from '@/lib/marketing';
import type { MarketingSkipReason } from '@/lib/types';

/*
 * Sends that were skipped, by reason. The map is keyed by the server's reason
 * slug; a slug this bundle does not know is shown as the slug itself rather
 * than dropped, so a newer server's reason is never silently missing.
 */

function labelOf(reason: string): string {
  return (SKIP_REASON_LABEL as Record<string, string>)[reason as MarketingSkipReason] ?? reason;
}

export function SkippedBreakdown({ skippedByReason }: { skippedByReason: Record<string, number> }) {
  const rows = Object.entries(skippedByReason).filter(([, count]) => count > 0);

  if (rows.length === 0) {
    return <EmptyState title="Nothing was skipped" />;
  }

  return (
    <dl className="m-0 grid gap-0 px-4 py-2">
      {rows.map(([reason, count]) => (
        <div
          key={reason}
          className="flex items-baseline justify-between gap-3 border-b border-border py-2 last:border-b-0"
        >
          <dt className="min-w-0 text-sm text-fg-secondary [overflow-wrap:anywhere]">{labelOf(reason)}</dt>
          <dd className="m-0 text-sm font-medium text-fg tabular">{count.toLocaleString()}</dd>
        </div>
      ))}
    </dl>
  );
}
